export default {
  /**
   * Thành công
   */
  Success: 1,

  /**
   * Thất bại
   */
  Fail: 0,
};
